import {useSrc} from '../../atoms/Image/helpers';
import {Ratio} from '../../atoms/Image/types';
import {imageWidths, initialBreakpoints} from './FullWidthImage';

export const useFullWidthSmallImage = ({
  ratio,
  src,
}: {
  ratio: Ratio;
  src: string;
}): string => {
  const {srcSet} = useSrc({
    breakpoints: initialBreakpoints,
    ratio,
    src,
    widths: imageWidths.slice(0, initialBreakpoints.length),
  });

  // Gets the URL of the smallest image from the source set.
  // It first gets the first image size definition and then takes the URL part.
  return srcSet.split(', ')[0]!.split(' ')[0]!;
};
